import {
  string as yupString,
  object as yupObject,
  boolean as yupBoolean,
  ref as yupRef,
} from "yup";

export function validateString(message) {
  return yupString(message);
}

export function oneOf(applyTo, enumerable, message) {
  return applyTo.oneOf(enumerable, message);
}

export function validateObject(obj) {
  return yupObject().shape(obj);
}

export function required(applyTo, message) {
  return applyTo.required(message);
}

export function validateBoolean(message) {
  return yupBoolean(message);
}

export function validateEmail(message) {
  return yupString().matches(
    new RegExp(
      /^(?!.*[^na-z0-9]{2})(?=.*[a-z0-9]$)[a-z0-9].*@[a-z0-9]+([\.-]?[a-z0-9_]+)*(\.[a-z]{2,10})+$/
    ),
    message
  );
}

export function validatePassword(message) {
  return yupString().matches(
    new RegExp(/^[a-zA-Z0-9!@#$%^&*+-_\(\)]+$/),
    message
  );
}

export function useRef(refName) {
  return yupRef(refName);
}

export function isSplit(pin) {
    return Math.floor(pin / 1024) === 1;
};